import module from 'cliente/module.js'

const schema = {
  tipo_id: 'number',
  activo: 'boolean',
}

export class ClienteInformacionRepresentanteService {
  constructor ($http) {
    this.$http = $http
  }

  get (clienteId, representanteId) {
    return this.$http.get('/api/clientes/cliente/informacion/representante', {
      params: {cliente_id: clienteId, representante_id: representanteId},
      clearCache: 'ClienteRepresentante',
      schema,
    })
  }

  put (clienteId, representanteId, data) {
    return this.$http.put('/api/clientes/cliente/informacion/representante', data, {
      params: {cliente_id: clienteId, representante_id: representanteId},
      clearCache: 'ClienteRepresentante',
      schema,
    })
  }
}

module.service('ClienteInformacionRepresentante', ClienteInformacionRepresentanteService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Representante.js